import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import StorefrontOutlined from "@mui/icons-material/StorefrontOutlined";
import { vendorMainColumnMaxWidthSx } from "../../../../config/vendorContentMaxWidth";
import { PRIMARY } from "../constants";
import { PROFILE_FIELD_BG } from "../profileFieldStyles";

function formatHeaderEmail(email) {
  const raw = String(email ?? "").trim();
  if (!raw) return "EMAIL NON IMPOSTATA";
  return raw.toUpperCase();
}

export function ProfileHeader({ companyName, email, base64, hasLogo }) {
  return (
    <Paper
      elevation={0}
      sx={{
        py: { xs: 4, sm: 2 },
        px: { xs: 0, sm: 5 },
        borderRadius: "14px",
        border: "1px solid rgba(0,0,0,0.06)",
        backgroundColor: "#ffffff",
        boxShadow: "0 8px 28px rgba(11, 61, 135, 0.07)",
        ...vendorMainColumnMaxWidthSx,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 3, md: 3 }}
        alignItems={{ xs: "center", md: "center" }}
        justifyContent="space-between"
        mx={0}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            flex: 1,
            minWidth: 0,
            pr: { md: 2 },
            width: { xs: "100%", md: "auto" },
            justifyContent: { xs: "center", md: "flex-start" },
          }}
        >
          <Box
            aria-hidden
            sx={{
              width: { xs: 60, sm: 100 },
              height: { xs: 60, sm: 100 },
              borderRadius: "50%",
              backgroundColor: PROFILE_FIELD_BG,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <StorefrontOutlined sx={{ color: PRIMARY, fontSize: { xs: 34, sm: 58 } }} />
          </Box>

          <Stack spacing={0.5} sx={{ minWidth: 0, alignItems: { xs: "center", md: "flex-start" } }}>
            <Typography
              sx={{
                fontFamily: "Rubik, sans-serif",
                fontWeight: 800,
                fontSize: { xs: "1.35rem", sm: "1.5rem", md: "1.6rem" },
                color: PRIMARY,
                lineHeight: 1.2,
                wordBreak: "break-word",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {companyName}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Rubik, sans-serif",
                fontSize: { xs: "0.875rem", sm: "0.9375rem" },
                fontWeight: 500,
                color: "rgba(0, 0, 0, 0.55)",
                letterSpacing: "0.02em",
                wordBreak: "break-word",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {formatHeaderEmail(email)}
            </Typography>
          </Stack>
        </Stack>

        <Box
          sx={{
            flexShrink: 0,
            alignSelf: { xs: "center", md: "center" },
            position: "relative",
            width: { xs: "min(100%, 320px)", sm: "min(100%, 360px)", md: 260 },
            minHeight: { xs: 100, sm: 120, md: 130 },
            maxHeight: { xs: 160, md: 140 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {hasLogo ? (
            <Box
              component="img"
              src={base64}
              alt=""
              sx={{
                display: "block",
                maxWidth: "100%",
                width: "auto",
                height: "auto",
                maxHeight: { xs: 150, sm: 160, md: 136 },
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: "5px",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            />
          ) : (
            <Typography
              sx={{
                fontFamily: "Rubik, sans-serif",
                fontSize: "0.875rem",
                color: "text.secondary",
                height: 123.5,
                width: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              Nessun logo caricato
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}
